export const RD_BUSINESS_COMPONENTS_UPLOAD_ONESCHEMA_TEMPLATE_KEY = 'rd-business-components-upload-v1';
